import { fetchOrchidAPI } from "./api";

/**
 * download file from different origin including credentials + cookie
 *
 * the object url will be revoked after download
 *
 * this method is used to download file from other domain since <a> attr: download only works for the same-origin url
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download
 * @param url download file link
 * @param [fileName=""] optional. download file name
 */
export default async function downloadFileChunk(
  url: string,
  fetchOptions?: Omit<RequestInit, "credentials" | "headers">,
  callback?: (arg: { receivedLength: number; contentLength?: number }) => void,
) {
  // Step 1: start the fetch and obtain a reader

  const response = await fetchOrchidAPI(url, {
    credentials: "include",
    mode: "cors",
    method: "GET",
    headers: {
      cookie: document.cookie,
    },
    ...fetchOptions,
  });

  const reader = (response.body as any).getReader();

  // Step 2: get total length
  const contentLength = +(response.headers.get("Content-Length") || 0);
  if (callback) {
    callback({
      receivedLength: 0,
      // contentLength,
    });
  }
  // Step 3: read the data
  let receivedLength = 0; // received that many bytes at the moment
  let chunks: any[] = []; // array of received binary chunks (comprises the body)

  while (true) {
    const { done, value } = await reader.read();

    if (done) {
      if (callback) {
        callback({
          receivedLength: contentLength,
          // contentLength,
        });
      }
      break;
    }

    chunks.push(value);
    receivedLength += value.length;
    if (callback) {
      callback({
        receivedLength,
        // contentLength,
      });
    }
  }

  // Step 4: concatenate chunks into single Uint8Array
  const unit8Array = new Uint8Array(receivedLength); // (4.1)
  let position = 0;
  for (let chunk of chunks) {
    unit8Array.set(chunk, position); // (4.2)
    position += chunk.length;
  }

  return unit8Array;
}
